export enum CheckoutActionTypes {
  RESET_CHECKOUT = 'checkout/RESET_CHECKOUT',
}
